// Сводный дэшборд проекта — первый пункт меню; заголовок тоже фильтруется по праву
export default [
  {
    header: 'Дэшборд',
    resource: 'dashboard',
    action: 'view',
  },
  {
    title: 'Своя Игра',
    route: 'dashboard-sifnf',
    icon: 'ActivityIcon',
    resource: 'dashboard',
    action: 'view',
  },
]
